import { useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Provider } from "react-redux";
import { store as appStore } from "./store";              // your app store
import Header from "./components/header";
import Sidebar from "./components/sidebar";
import Dashboard from "./pages/dashboard";
import ClientsPage from "./pages/ClientsPage";
import TemplateEditor from "./pages/templateEditor";
import "./App.css";
import * as Dcmm from "@industronics/dcmm";
import { createSocket, SocketProvider } from "@industronics/socket";
import { auth } from "./utils/httpClient";
import BillingTransactionsPage from "./pages/BillingTransactionsPage";
import { getSelectedOwnerFromCookie } from "@industronics/fids-utils";


export default function App() {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const ownerId = getSelectedOwnerFromCookie();
  const socket = createSocket(process.env.REACT_APP_SOCKET_URL!, {
    query: { ownerId },
    auth: {
      token: auth.accessToken ?? process.env.REACT_APP_ACCESS_TOKEN,
    },
  });
  return (
    <Provider store={appStore}>
      <SocketProvider socket={socket}>
        <BrowserRouter>
          <div className="h-screen w-screen overflow-hidden bg-gray-50 flex flex-col">
            <Header
              isSidebarOpen={sidebarOpen}
              onSidebarToggle={setSidebarOpen}
            />
            <div className="flex flex-1 overflow-hidden">
              <Sidebar collapsed={!sidebarOpen} />
              <main className="flex-1 overflow-auto">
                <Routes>
                  <Route path="/" element={<Navigate to="/dashboard" replace />} />
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/clients" element={<ClientsPage />} />
                  <Route path="/billing-transactions" element={<BillingTransactionsPage />} />


                  {/* Add Screen Editor route */}
                  <Route path="/devices" element={<Dcmm.DeviceManager />} />

                  <Route path="/screen-editor" element={<TemplateEditor />} />

                  <Route path="/announcements" element={<Dcmm.AnnouncementsTabsPage />} />
                  <Route path="/assign-announcement/:id" element={<Dcmm.AssignDisplayLayoutAnnouncement />} />


                  <Route path="/display-layouts/*" element={<Dcmm.DisplayLayoutManager />} />
                  <Route path="/cluster/*" element={<Dcmm.ClustersManager />} />
                  <Route path="/ads/*" element={<Dcmm.AdsManagement />} />
                  <Route path="/cluster-device-management/:id" element={<Dcmm.ClusterDisplayLayoutManagement />} />
                  <Route path="/assign-ads/:id" element={<Dcmm.AssignDisplayLayoutAds />} />

                  <Route path="/flight-removal-offsets" element={<Dcmm.FlightRemovalOffsetTable />} />
                  <Route path="*" element={<Navigate to="/dashboard" replace />} />
                </Routes>
              </main>
            </div>
          </div>
        </BrowserRouter>
      </SocketProvider>
    </Provider>
  );
}
